















import Component, { mixins } from 'vue-class-component';

import Form from '@/general/abstract/form/mixin/Form';

import FormBase from '@/general/abstract/form/FormBase.vue';
import { VModel } from 'vue-property-decorator';
import { ModelFormModel } from '@/context/model/model/ModelFormModel';
import ModelRouter from '@/context/model/router/ModelRouter';
import { Model } from '@/context/model/component/Model';
import { ModelApi } from '@/context/model/api/ModelApi';
import ModelFormTemplate from '@/context/model/component/ModelFormTemplate.vue';

@Component({
  components: {
    FormBase,
    ModelFormTemplate
  }
})
export default class ModelForm extends mixins<Form<ModelFormModel, ModelFormModel, Model>>(Form) {
  @VModel({ default: new ModelFormModel() }) model!: ModelFormModel;

  buildCmd(): ModelFormModel {
    if (this?.model?.id) {
      return this.model;
    }
    let command: Record<string, unknown> = Object.assign<Record<string, unknown>, ModelFormModel>(
      {},
      this.model
    );
    delete command.id;
    return command;
  }

  async submitApi(cmd: ModelFormModel): Promise<Model> {
    const model: Promise<Model> = cmd.id
      ? ModelApi.instance().update<ModelFormModel, Model>(cmd)
      : ModelApi.instance().create<ModelFormModel, Model>(cmd);
    return model;
  }

  showRoute(id: number): Record<string, unknown> {
    return ModelRouter.instance().show(id);
  }
}
